import {Dispatch} from "redux";
import {setUserValue} from "../reducers/userReducer";

export const login = async (dispatch: Dispatch, email: string, password: string) => {
    try {
        const user = JSON.parse(localStorage.getItem('user') as any);
        if (user.email === email && user.password === password) {
            // dispatch(setUserValue({key: 'currentUser', value: user}));
            dispatch(setUserValue({key: 'isAuth', value: true}));
            // dispatch(loginSuccess(user));
            sessionStorage.setItem('user', JSON.stringify(user));
            console.log(`user ${email} successfully logged in`);
            return true;
        } else {
            /*dispatch(setUserValue({key: 'currentUser', value: {
                name: '',
                email: '',
                phone: '',
                password: '',
                }}));*/
            // dispatch(loginUpdate('Неверный логин или пароль'));
            console.log(`user ${email} not exist or password is incorrect`);
            return false;
        }
        /*const response = await fetch('http://localhost:5000/api/auth/login', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email, password})
        });
        const data = await response.json();
        dispatch(loginSuccess(data));*/
        //dispatch(loginSuccess({email, password}));
        //console.log(`user ${email} successfully logged in`);
    } catch (e) {
        console.log(e);
    }
}

export const registration = async (dispatch: Dispatch, name: string, email: string, phone: string, password: string) => {
    try {
        sessionStorage.setItem('user', JSON.stringify({name, email, phone, password}));
        localStorage.setItem('user', JSON.stringify({name, email, phone, password}));
        // dispatch(setUser({name, email, phone, password}));

        // dispatch(setUserValue({key: 'currentUser', value: {name, email, phone, password}}));
        dispatch(setUserValue({key: 'isAuth', value: true}));

        console.log(`user ${name} successfully registered`);
        return true;
        /*const response = await fetch('http://localhost:5000/api/auth/registration', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({name, email, phone, password})
        });
        const data = await response.json();
        dispatch(loginSuccess(data));*/
    } catch (e) {
        console.log(e);
    }
}

export const auth = async (dispatch: Dispatch) => {
    try {
        const user = JSON.parse(sessionStorage.getItem('user') as any);
        if (user.email) {
            // dispatch(loginSuccess(user));

            // dispatch(setUserValue({key: 'currentUser', value: user}));
            dispatch(setUserValue({key: 'isAuth', value: true}));

            console.log(`user ${user.email} successfully logged in`);
            return true;
        } else {
            console.log(`user not logged in`);
            return false;
        }
        /*const response = await fetch('http://localhost:5000/api/auth/auth', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            credentials: 'include'
        });
        const data = await response.json();
        dispatch(loginSuccess(data));*/
    } catch (e) {
        console.log(e);
    }
}

export const logout = async (dispatch: Dispatch) => {
    try {
        sessionStorage.removeItem('user');
        if (sessionStorage.getItem('user') === null) {
            console.log(`user successfully logged out`);
            return true;
        }
        // dispatch(logoutUser());

        /*dispatch(setUserValue({key: 'currentUser', value: {
            name: '',
            email: '',
            phone: '',
            password: '',
        }}));*/
        dispatch(setUserValue({key: 'isAuth', value: false}));

        console.log(`user successfully logged out`);
    } catch (e) {
        console.log(e);
    }
}

export const update = async (dispatch: Dispatch, name: string, email: string, phone: string, password: string) => {
    try {
        const existUser = JSON.parse(sessionStorage.getItem('user') as any);
        if (existUser.password === password) {
            sessionStorage.setItem('user', JSON.stringify({name, email, phone, password}));
            // dispatch(updateUser({name, email, phone, password}));

            // dispatch(setUserValue({key: 'currentUser', value: {name, email, phone, password}}));

            console.log(`user ${name} successfully updated`);
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e);
    }
}

export const updatePassword = async (dispatch: Dispatch, password: string, newPassword: string) => {
    try {
        const existUser = JSON.parse(sessionStorage.getItem('user') as any);
        if (existUser.password === password) {
            sessionStorage.setItem('user', JSON.stringify({...existUser, password: newPassword}));
            // dispatch(updateUser({...existUser, password: newPassword}));

            // dispatch(setUserValue({key: 'currentUser', value: {...existUser, password: newPassword}}));

            console.log(`user password successfully updated`);
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e);
    }
}

export const getUserOrders = async () => {
    try {
        const user = JSON.parse(sessionStorage.getItem('user') as any);
        if (user.email) {
            const testUserData = [
                {
                    id: 1,
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    password: user.password,
                    userOrders:
                        {
                            categories: [
                                'Current',
                                'Purchase history'
                            ],
                            currentOrders: [
                                {
                                    subcategory: 'Pending',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                                            name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'SFB Minsk (0.6 km)',
                                            available: 8,
                                            validUntil: ['10:00', '16:30', '18:00', '22:00'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian'],
                                            categoryName: 'Sushi set',
                                            orderTime: '16:30',
                                            paidStatus: true,
                                            orderQrCode: `${process.env.PUBLIC_URL}/testData/order-qr-code.png`,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-2.png`,
                                            name: 'Sushi mix - 6 PC NIGIRI + 6 PC TEMPURA',
                                            price: '300 kr',
                                            discount: '175 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 7,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian'],
                                            categoryName: 'Sushi set',
                                            orderTime: '11:30',
                                            paidStatus: false,
                                            orderQrCode: `${process.env.PUBLIC_URL}/testData/order-qr-code.png`,
                                        },
                                        {
                                            id: 3,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                                            name: 'Pumpkin cream soup with pink peppercorn',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'SFB Minsk (0.6 km)',
                                            available: 3,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['soup', 'indian', 'asian'],
                                            categoryName: 'indian',
                                            orderTime: '13:25',
                                            paidStatus: false,
                                            orderQrCode: `${process.env.PUBLIC_URL}/testData/order-qr-code.png`,
                                        }
                                    ]
                                },
                                {
                                    subcategory: 'Confirmed',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            orderTime: '09:00',
                                            paidStatus: true,
                                            orderQrCode: `${process.env.PUBLIC_URL}/testData/order-qr-code.png`,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-3.png`,
                                            name: 'Sushi mix - 3 pc Nigiri sushi 3 salmon 3 tuna + 4 roll',
                                            price: '250 kr',
                                            discount: '185 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 12,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15', '17:55'],
                                            descriptionSpend: 'Mininum 220 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian', 'salmon', 'tuna'],
                                            categoryName: 'Sushi set',
                                            orderTime: '1:55',
                                            paidStatus: false,
                                            orderQrCode: `${process.env.PUBLIC_URL}/testData/order-qr-code.png`,
                                        }
                                    ]
                                }
                            ],
                            purchaseHistoryOrders: [
                                {
                                    subcategory: 'Pending',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                                            name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'SFB Minsk (0.6 km)',
                                            available: 8,
                                            validUntil: ['10:00', '16:30', '18:00', '22:00'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian'],
                                            categoryName: 'Sushi set',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 3,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                                            name: 'Pumpkin cream soup with pink peppercorn',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'SFB Minsk (0.6 km)',
                                            available: 3,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['soup', 'indian', 'asian'],
                                            categoryName: 'indian',
                                            paidStatus: false,
                                        }
                                    ]
                                },
                                {
                                    subcategory: 'Canceled',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-2.png`,
                                            name: 'Sushi mix - 6 PC NIGIRI + 6 PC TEMPURA',
                                            price: '300 kr',
                                            discount: '175 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 7,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian'],
                                            categoryName: 'Sushi set',
                                            paidStatus: false,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                    ]
                                },
                                {
                                    subcategory: 'Confirmed',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/sushi-3.png`,
                                            name: 'Sushi mix - 3 pc Nigiri sushi 3 salmon 3 tuna + 4 roll',
                                            price: '250 kr',
                                            discount: '185 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 12,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15', '17:55'],
                                            descriptionSpend: 'Mininum 220 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['sushi', 'japanese', 'asian', 'salmon', 'tuna'],
                                            categoryName: 'Sushi set',
                                            paidStatus: false,
                                        }
                                    ]
                                },
                                {
                                    subcategory: 'Return',
                                    orders: [
                                        {
                                            id: 1,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                                            name: 'Pumpkin cream soup with pink peppercorn',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'SFB Minsk (0.6 km)',
                                            available: 3,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['soup', 'indian', 'asian'],
                                            categoryName: 'indian',
                                            paidStatus: false,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                        {
                                            id: 2,
                                            image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                                            name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                                            price: '200 kr',
                                            discount: '150 kr',
                                            place: 'Cort Adelers Gate 2, 0254 Oslo',
                                            available: 11,
                                            validUntil: ['09:00', '11:30', '13:25', '16:15'],
                                            descriptionSpend: 'Mininum 300 kr spend',
                                            descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                                            tags: ['chicken', 'indian', 'achari'],
                                            categoryName: 'indian',
                                            paidStatus: true,
                                        },
                                    ]
                                }
                            ],
                        },
                }
            ]
            /*const response = await fetch(`http://localhost:5000/api/order/user/${user.email}`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
                credentials: 'include'
            });
            const data = await response.json();
            return data;*/
            return testUserData;
        } else {
            return [];
        }
    } catch (e) {
        console.log(e);
    }
}